import styled, { keyframes } from "styled-components";
import { tokens } from "@swiggy-private/dls-web-common/dist/components/tokens";

const paymentIconDimensions = 32;
const paymentCtaHeight = 58;
const sliderButtonBorderRadius = 56;

const gradientShimmer = keyframes`
    0% {
        background-position: -1000px 0;
    }

    100% {
        background-position: 1000px 0;
    }
`;

const ShimmerDiv = styled.div`
    background: linear-gradient(
        90deg,
        ${tokens.colors.slateAlpha15} 0%,
        ${tokens.colors.slateAlpha05} 52.08%,
        ${tokens.colors.slateAlpha15} 100%
    );
    background-size: 1000px 100%;
    animation: ${gradientShimmer} 3s infinite linear;
`;

export const ShimmerContainer = styled.div`
    bottom: 0;
    width: 100%;
    border-radius: ${(props) => props.theme.cornerRadius.small} ${(props) => props.theme.cornerRadius.small} 0 0;
    background: ${(props) => props.theme.colors[props.theme.colorMode].background_Primary};
    padding: ${(props) => props.theme.spacing.medium} ${(props) => props.theme.spacing.medium} 0
        ${(props) => props.theme.spacing.medium};
`;

export const ShimmerContent = styled.div`
    display: flex;
`;

export const PaymentMethodIcon = styled(ShimmerDiv)`
    border-radius: ${(props) => props.theme.cornerRadius.xSmall};
    width: ${paymentIconDimensions}px;
    height: ${paymentIconDimensions}px;
`;

export const ShimmerTextContainer = styled.div`
    display: flex;
    padding-left: ${(props) => props.theme.spacing.small};
    flex-grow: 1;
    justify-content: space-between;
    align-items: center;
`;

export const TextPlaceholder = styled(ShimmerDiv)<{ height?: number; width?: number }>`
    height: ${(props) => props.height || 15}px;
    width: ${(props) => props.width || 96}px;
    border-radius: ${(props) => props.theme.cornerRadius.xxxSmall};
    margin-bottom: ${(props) => props.theme.spacing.xxxSmall};
`;

export const PrimaryCta = styled(ShimmerDiv)`
    border-radius: ${sliderButtonBorderRadius}px;
    margin-top: ${(props) => props.theme.spacing.medium};
    height: ${paymentCtaHeight}px;
`;
